'use client';

import { memo } from 'react';
import { HeaderConnectionBannerItemValue } from '@headless-workspace/core-domain';
import { ComponentMemo } from '@headless-workspace/typings';
import { DynamicConnectionBanner } from './DynamicConnectionBanner';
import { StaticConnectionBanner } from './StaticConnectionBanner';

export type ConnectionBannerItemWrapperProps = HeaderConnectionBannerItemValue & {
    connectionDataLayer?: string;
};

export const ConnectionBannerItemWrapper: ComponentMemo<ConnectionBannerItemWrapperProps> = memo(
    ({ dynamicOverlayIcons, dynamicHref, dynamicLabel, ...props }) => {
        const dynamicData = dynamicOverlayIcons ?? dynamicLabel ?? dynamicHref;

        return dynamicData ? (
            <DynamicConnectionBanner dynamicData={dynamicData} {...props} />
        ) : (
            <StaticConnectionBanner {...props} />
        );
    },
);

ConnectionBannerItemWrapper.displayName = 'ConnectionBannerItemWrapper';
